import { uri } from '../../api-endpoint';
import { deleteTemplateFn } from '../common';

export const deleteUser = (token: string) => (userId: number) =>
  deleteTemplateFn(token, uri.accountById(userId));
